export const environment = {
  production: true,
  appUrl: 'https://my.tmb.ie',
  serviceApi: 'https://exodusiiiuatapi.azurewebsites.net',
  reportServer: 'https://exodusiiiuatreporting.azurewebsites.net',
  authConfig: {
    authApi: 'https://exodusiiiuatapi.azurewebsites.net',
    realm: 'Exodus III - MyTmb - Live - ResourceOwner',
    clientId: 'ExodusIII.MyTmb_ResourceOwner',
    scope:'openid stepone_api_accountmanagement offline_access'
  }
};



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/environments/environment.ts